import React from "react";
import Header from "./components/Header.jsx";
import Form from "./components/Form.jsx";

function App() {
  return (
    <main>
      <Header />
      <Form />
    </main>
  );
}

export default App;
